export default __webpack_public_path__ + "static/media/book.1ee4fff5.png";